import React from "react";
import "../css/CryptoHero.css";
import trumpImage from "../images/trump1.png";

// Иконки Bootstrap
import { CheckCircle, Building, CashCoin, Globe } from "react-bootstrap-icons";

const TrumpCryptoBlock = () => {
  return (
    <div className="box">
      <section className="_trump-crypto">
        <div className="container">
          <div className="trump-content">
            {/* Левая часть — текст */}
            <div className="trump-text">
              <h2>
                Donald Trump's <span>Crypto</span> Vision
              </h2>
              <h3>
                Rebuilding America's <br />
                <span>Digital Future</span>
              </h3>
              
              <div className="trump-achievements">
                <div className="achievement-item">
                  <span className="achievement-icon">
                    <CheckCircle size={28} />
                  </span>
                  <div>
                    <strong>Pro-Crypto Stance</strong>
                    <p>First U.S. president to actively embrace cryptocurrency and blockchain innovation</p>
                  </div>
                </div>
                <div className="achievement-item">
                  <span className="achievement-icon">
                    <Building size={28} />
                  </span>
                  <div>
                    <strong>Regulatory Reform</strong>
                    <p>Pushed for clear, business-friendly crypto regulations to keep innovation in America</p>
                  </div>
                </div>
                <div className="achievement-item">
                  <span className="achievement-icon">
                    <CashCoin size={28} />
                  </span>
                  <div>
                    <strong>Digital Dollar Initiative</strong>
                    <p>Spearheaded the development of a U.S. digital currency framework</p>
                  </div>
                </div>
                <div className="achievement-item">
                  <span className="achievement-icon">
                    <Globe size={28} />
                  </span>
                  <div>
                    <strong>Global Leadership</strong>
                    <p>Positioned the U.S. as the world's crypto capital, competing with China and Europe</p>
                  </div>
                </div>
              </div>

              <div className="trump-quote">
                <p>
                  "We will make America the <span>crypto capital</span> of the world. 
                  We are going to embrace the future, not run from it."
                </p>
                <span className="quote-author">— Donald J. Trump</span>
              </div>
            </div>

            {/* Правая часть — картинка */}
            <div className="trump-image-wrapper">
              <img 
                src={trumpImage} 
                alt="Donald Trump - Crypto Vision" 
                className="trump-image"
              />
              <div className="trump-image-glow"></div>
              <div className="trump-flag-overlay">🇺🇸</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrumpCryptoBlock;